export const PERSON_DATA_NAME_STORAGE = "PersonDataNameStorage";
export const APPLICATION_DATA_NAME_STORAGE = "ApplicationDataNameStorage";
export const IS_SESSION_STARTED = "isSessionStarted";
export const QUERY_PARAM_INIT = "queryParamInitial";
export const MS_TIME_START_OTP = "msTimeExpiredOTP";